import React, { FC } from 'react';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

export const Iconify: FC<any> = ({ icon, width = 20, sx, ...other }) => (
    <Box component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
);
